import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useProfileQuery } from "@/hooks/profile/useProfileQuery";

interface CreateReservationData {
  item_id: string;
  reservation_date: string;
  start_time: string;
  end_time: string;
  total_price: number;
}

export const useCreateReservation = () => {
  const queryClient = useQueryClient();
  const { data: profile } = useProfileQuery();

  return useMutation({
    mutationFn: async (data: CreateReservationData) => {
      if (!profile?.id) throw new Error("Usuario no autenticado");

      const { data: reservation, error } = await supabase
        .from('reservations')
        .insert({
          user_id: profile.id,
          ...data,
          status: 'confirmed'
        })
        .select()
        .single();

      if (error) throw error;
      return reservation;
    },
    onSuccess: (reservation) => {
      // Invalidate specific user reservations to match the query key pattern
      if (profile?.id) {
        queryClient.invalidateQueries({ queryKey: ['user-reservations', profile.id] });
      }
      // Also invalidate the general pattern in case other components use it
      queryClient.invalidateQueries({ queryKey: ['user-reservations'] });
      toast.success("Reserva creada exitosamente");
    },
    onError: (error) => {
      toast.error("Error al crear la reserva: " + error.message);
    },
  });
};